import { render, staticRenderFns } from "./WeatherForecast.vue?vue&type=template&id=49faa542"
import script from "./WeatherForecast.vue?vue&type=script&lang=ts"
export * from "./WeatherForecast.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports